import { lazy } from "react";

const loadSessionSettingsDialogModule = () =>
    import("./SessionSettingsDialog").then((module) => ({
        default: module.SessionSettingsDialog,
    }));

export const SessionSettingsDialog = lazy(loadSessionSettingsDialogModule);

export function preloadSessionSettingsDialog() {
    void loadSessionSettingsDialogModule();
}
